import { useState } from "react";
import { toast } from "sonner";
import { subscribeLead } from "../lib/api";
import { logError } from "../lib/logger";

export function useNewsletter() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;
        try {
            setLoading(true);
            await subscribeLead(email);
            toast.success("You're on the list — market briefings inbound.");
            setEmail("");
        } catch (err) {
            logError("Newsletter subscribe failed:", err);
            toast.error("Could not subscribe. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return { email, setEmail, loading, onSubscribe };
}
